define('mhi_kitcheckout.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('mhi_kitcheckout', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div></div> ";
},"useData":true}, 'extensions/MHI/KitSubItems/1.0.0/', 'extensions/MHI/KitSubItems/1.0.0/', Handlebars);
});